import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-userLog",
  "use": "icon-userLog-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-userLog\"><defs><style type=\"text/css\"></style></defs><path d=\"M568.889 910.222h-512V113.778h739.555V512h-56.888V170.667H113.778v682.666H512z\" fill=\"#409EFF\" p-id=\"3942\" /><path d=\"M711.111 512c108.089 0 199.111 91.022 199.111 199.111S819.2 910.222 711.112 910.222 512 819.2 512 711.112 603.022 512 711.111 512m0-56.889c-142.222 0-256 113.778-256 256s113.778 256 256 256 256-113.778 256-256-113.778-256-256-256zM227.556 56.89h56.888v170.667h-56.888z m341.333 0h56.889v170.667h-56.89zM170.667 341.333h512v56.89h-512z m0 170.667H455.11v56.889H170.667z m0 170.667h227.555v56.889H170.667z\" fill=\"#409EFF\" p-id=\"3943\" /><path d=\"M853.333 796.444H682.667V568.89h56.889v170.667h113.777z\" fill=\"#409EFF\" p-id=\"3944\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/userLog.svg
// module id = siXo
// module chunks = 2